module.exports = __webpack_public_path__ + "img/bank_icon15.58db797d.png";